import React from "react";
import { connect } from "react-redux";
import { compose } from "react-recompose";

const MomentOfTruth = ({ client, active, onClick }) => {
  return (
    <svg width="32" height="27.066" viewBox="0 0 32 27.066" onClick={onClick} className="pointer">
      {active ? (
        <path
          d="M14.764,26.8,2.507,14.548A8.515,8.515,0,1,1,14.549,2.507l.855.855.842-.842A8.519,8.519,0,1,1,28.287,14.574L16,26.812a.874.874,0,0,1-1.24-.007Z"
          fill={client?.secondaryColor}
        />
      ) : (
        <g transform="translate(0 -28.501)">
          <path
            d="M28.3,31.014a8.524,8.524,0,0,0-12.055.007l-.842.842-.855-.855a8.517,8.517,0,0,0-12.055-.013,8.517,8.517,0,0,0,.013,12.055L14.764,55.306a.875.875,0,0,0,1.24.007L28.287,43.075A8.54,8.54,0,0,0,28.3,31.014ZM27.047,41.828,15.384,53.446,3.747,41.809A6.756,6.756,0,1,1,13.3,32.254l1.475,1.475a.878.878,0,0,0,1.247,0l1.462-1.462a6.761,6.761,0,0,1,9.562,9.562Z"
            transform="translate(0)"
            fill={client?.secondaryColor}
          />
        </g>
      )}
    </svg>
  );
};

const mapStateToProps = state => ({
  client: state.client.client,
});

export default compose(connect(mapStateToProps, null))(MomentOfTruth);
